// MUI base styles
import colors from "../../base/colors";
import borders from "../../base/borders";
import boxShadows from "../../base/boxShadows";

// MUI helper functions
import pxToRem from "../../functions/pxToRem";

const {grey, white} = colors;
const {borderRadius} = borders;
const {tabsBoxShadow} = boxShadows;

const tabs: any = {
    styleOverrides: {
        root: {
            position: "relative",
            backgroundColor: white.main,
            minHeight: "unset",
        },


        flexContainer: {
            height: "100%",
            position: "relative",
            zIndex: 10,
        },
    }
    //
    //     fixed: {
    //         overflow: "unset !important",
    //         overflowX: "unset !important",
    //     },
    //
    //     vertical: {
    //         "& .MuiTabs-indicator": {
    //             width: "100%",
    //         },
    //     },
    //
    //     indicator: {
    //         height: "100%",
    //         borderRadius: borderRadius.sm,
    //         backgroundColor: white.main,
    //         boxShadow: "none",
    //         transition: "all 500ms ease",
    //         borderBottom: "solid #E09145 2px",
    //     },
    // },
};

export default tabs;
